export const jobTypeEnum = [{ id: 'JAVASCRIPT', label: 'Javascript' }, { id: 'GROOVY', label: 'Groovy skript' }];



// WEBPACK FOOTER //
// ./src/modules/jobs/_jobsEnums.ts